// --------------------------------------------------------------------------
// #40 – CONTENT HIGHLIGHT GRID
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var ModalDisplay = require('./modal');
var modalDisplay = new ModalDisplay();
var debounce = require('../utilities/debounce');

// jquery plugins
require('../plugins/slick');

module.exports = function (options) {
    var context = options.context,
        $mosaicItem = context.find('.content-highlight-item, .content-highlight-item--large'),
        internalExists = false,
        externalExists = false,
        speed = context.data('speed');

    if (window.matchMedia) {
        var mq = window.matchMedia('screen and (max-width: 768px)');
        var mqMedium = window.matchMedia('screen and (max-width: 960px)');
    }

    function init() {

        /**
         * Rotates through items and selects them one by one
         */
        var itemIndex = 0;
        var itemCount = $mosaicItem.length;
        var itemHoverClass = 'hover';

        $($mosaicItem[0]).addClass(itemHoverClass);

        // 'speed' should come in from the data attribute as a value between 1-10. x by 1000 to put it into seconds
        setInterval(function () {
            $($mosaicItem).removeClass(itemHoverClass);
            $($mosaicItem[itemIndex]).addClass(itemHoverClass);
            itemIndex++;
            if (itemIndex === itemCount) {
                itemIndex = 0;
            }
        }, parseInt(speed) * 1000);

        /**
         * Initialise modal window
         */
        function callModal() {
            if (mq.matches) {
                if (!externalExists) {
                    if (internalExists) {
                        internalExists = false;
                        modalDisplay.destroyInternalModal($mosaicItem);
                    }
                    externalExists = true;
                    modalDisplay.externalModal($mosaicItem, $mosaicItem.find('.overlay'), 'content-highlight');
                }
            } else {
                if (!internalExists) {
                    if (externalExists) {
                        externalExists = false;
                        modalDisplay.destroyExternalModal($mosaicItem);
                    }
                    internalExists = true;
                    modalDisplay.internalModal($mosaicItem);
                }
            }
        }

        /**
         * Initialise slick carousel for mobile only
         */
        function callSlick() {
            var $jqcontentHighlightSlider = context;
            if (mqMedium.matches) {
                if ($jqcontentHighlightSlider.hasClass('slick-initialized')) {
                    $jqcontentHighlightSlider.slick('unslick');
                }
                $jqcontentHighlightSlider.slick({
                    dots: true,
                    arrows: false
                });
            } else {
                if ($jqcontentHighlightSlider.hasClass('slick-initialized')) {
                    $jqcontentHighlightSlider.slick('unslick');
                }
            }
        }

        // Call modal function
        callModal();

        // Call slick function
        callSlick();

        // debouncing the modal window
        $(window).on('resize', debounce(function () {
            callModal();
            callSlick();
        }, 500));
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/content-highlight.js
// module id = 197
// module chunks = 0